import { faBrush } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Label, Popover, PopoverContent, PopoverTrigger } from '@playcastdotio/Shadcn';
import clsx from 'clsx';
import { useState, useEffect } from 'react';

type ThemePickerProps = 'theme-midnight' | 'theme-gray';

const themes: {
  code: ThemePickerProps;
  color: string;
  name: string;
}[] = [
  {
    code: 'theme-midnight',
    color: 'bg-sky-800',
    name: 'Midnight',
  },
  {
    code: 'theme-gray',
    color: 'bg-gray-600',
    name: 'Gray',
  },
];

export const ThemePicker = () => {
  const [show, setShow] = useState(localStorage.getItem('show-theme-switcher-button') === 'true' || false);
  const [theme, setTheme] = useState<ThemePickerProps>((localStorage.getItem('theme') as ThemePickerProps) || 'theme-midnight');

  useEffect(() => {
    document.documentElement.className = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  // if ctrl + T is pressed, toggle the theme switcher button
  window.addEventListener('keydown', (e) => {
    if (e.key === 't' && e.ctrlKey) {
      setShow(!show);
      localStorage.setItem('show-theme-switcher-button', show ? 'false' : 'true');
    }
  });

  if (!show) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button className='text-primary bg-bright focus:bg-bright active:bg-bright hover:bg-brighter theme-midnight:shadow-[inset_2px_3px_2px_#A9E8EA,inset_-2px_-3px_2px_#2D618C] m-0 size-8 cursor-pointer p-0 px-3 font-semibold'>
          <FontAwesomeIcon icon={faBrush} className='text-darkest size-5' />
        </Button>
      </PopoverTrigger>
      <PopoverContent align='end' className='flex w-fit flex-col gap-4 border-none bg-neutral-50'>
        <Label>Theme: </Label>
        <div className='flex flex-col gap-0.5'>
          {themes.map((t) => (
            <button
              key={t.code}
              onClick={() => setTheme(t.code)}
              className={clsx(
                theme === t.code
                  ? 'border-amber-400 hover:border-opacity-60'
                  : 'hover:border-dark hover:border-dark/60 border-transparent hover:border-dashed',
                'flex items-center gap-2 rounded-lg border-2 px-2 py-1',
              )}
            >
              <div className={clsx('size-5 rounded-full p-2', t.color)} />
              <Label className='cursor-pointer font-normal'>{t.name}</Label>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
